import * as React from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { readUserAgent, userAgent } from '../../functions/analyseUserAgent';

class ResponsiveDialog extends React.Component<any, { open: boolean }> {
  public mounted : boolean = false;
  constructor(props: any) {
    super(props);
    this.state = {
      open: false
    };
  }

  public componentDidMount() {
    this.mounted = true;
  }

  public componentWillUnmount(){
    this.mounted = false;
  }

  public handleClickOpen = () => {
    if (this.mounted) {
      this.setState({ open: true });
    }
  };

  public handleClose = () => {
    if (this.mounted) {
      this.setState({ open: false });
    }
  };

  public render() {
    return (
      <div className="dialog">
        <Button
          variant="outlined"
          color="secondary"
          onClick={this.handleClickOpen}
        >
          User Agent Information
        </Button>
        <Dialog
          fullScreen={false}
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">
            Custom User Agent Information
          </DialogTitle>
          <DialogContent>
            {printUserAgent()}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary" autoFocus={true}>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withMobileDialog()(ResponsiveDialog);

function printUserAgent() {
  readUserAgent();
  return (
    <DialogContentText>
      App: {userAgent.isApp ? "Ja" : "Nein"}, 
      Android:{" "} {userAgent.isAndroid ? "Ja" : "Nein"}, 
      IOS:{" "} {userAgent.isIOS ? "Ja" : "Nein"}, 
      AR-fähig{" "} {userAgent.isARAble ? "JA" : "Nein"}{" "}
    </DialogContentText>
  );
} 


// WEBPACK FOOTER //
// ./src/components/home/Dialog.tsx